<template lang="">
<!--~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Start Server Requirements Page
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~-->
<div class="build-section doc-wrapper doc-inner">
    <div class="row">
        <div class="col-xl-12">
            <div class="build-wrapper">
                <h2 class="inner-title">Build & Run Guide</h2>
                <ul class="configure-list">
                    <li class="mb-10"><b>Run the Android Application:</b>
                        <ol>
                            <li><b>Select Android Device:</b> In Android Studio, select an Android device from the target selector for running the app. If no device is available, create one using <code>Tools > Android > <a href="https://developer.android.com/studio/run/managing-avds" target="_blank" class="redirect-link">AVD Manager</a></code>.</li>
                            <li><b>Run the App:</b> Click the run icon in the toolbar or select <code>Run > Run from the menu</code>. This will initiate the app’s deployment and execution on the selected Android device.</li>
                            <li>If you prefer the command line:</li>
                            <pre class="prettyprint mb-0">flutter run</pre>
                            <div class="row">
                                <div class="col-xl-7">
                                    <a class="img-popup">
                                        <img src="/product/efunding/documentation/assets/images/developmentAndTesting/app_run.webp" alt="build">
                                    </a>
                                </div>
                            </div>
                        </ol>
                    </li>
                    <li class="mb-10"><b>Run the iOS Application:</b>
                        <ol>
                            <li><b>Prepare Flutter App on Mac:</b> Ensure you have a test Flutter app set up on your Mac.</li>
                            <li><b>Device Trust:</b> On your iPhone, navigate to <code>Settings > General > Device Management</code> or Profile, and trust “Your Developer Name” to enable testing.</li>
                            <li><b>Xcode Setup:</b> Install CocoaPods using the following command in the terminal:</li>
                            <pre class="prettyprint mb-0">$ sudo gem install cocoapods</pre>
                            <div class="row">
                                <div class="col-xl-7">
                                    <a class="img-popup">
                                        <img src="/product/efunding/documentation/assets/images/developmentAndTesting/install_cocoapods.webp" alt="build">
                                    </a>
                                </div>
                            </div>
                            <li><b>Open Xcode Workspace:</b> Locate the <code>Runner.xcworkspace</code> file inside the <code>ios</code> folder of your Flutter project directory. Open this file in Xcode using the command:</li>
                            <pre class="prettyprint mb-0">$ open ios/Runner.xcworkspace</pre>
                            <div class="row">
                                <div class="col-xl-7">
                                    <a class="img-popup">
                                        <img src="/product/efunding/documentation/assets/images/developmentAndTesting/runner_xcworkspace.webp" alt="build">
                                    </a>
                                </div>
                            </div>
                            <li><b>Configure Signing & Capabilities:</b> In Xcode, navigate to the Runner file in the left menu bar and go to the Signing & Capabilities page. Click “Add an Account” to add your Apple ID and password. Then, change the Bundle Identifier to a unique value.</li>
                            <div class="row">
                                <div class="col-xl-7">
                                    <a class="img-popup">
                                        <img src="/product/efunding/documentation/assets/images/developmentAndTesting/add_account.webp" alt="build">
                                    </a>
                                    <div class="col-xl-7">
                                        <a class="img-popup">
                                            <img src="/product/efunding/documentation/assets/images/developmentAndTesting/apple_id.webp" alt="build">
                                        </a>
                                    </div>
                                    <div class="col-xl-7">
                                        <a class="img-popup">
                                            <img src="/product/efunding/documentation/assets/images/developmentAndTesting/identity.webp" alt="build">
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <li><b>Connect iPhone:</b> Connect your iPhone to your Mac. In Xcode, select your iPhone device from the device list.</li>
                            <div class="row">
                                <div class="col-xl-7">
                                    <a class="img-popup">
                                        <img src="/product/efunding/documentation/assets/images/developmentAndTesting/connect_phone.webp" alt="build">
                                    </a>
                                </div>
                                <div class="col-xl-7">
                                    <a class="img-popup">
                                        <img src="/product/efunding/documentation/assets/images/developmentAndTesting/select_iphone.webp" alt="build">
                                    </a>
                                </div>
                            </div>
                            <li><b>Build and Run:</b> Click the play button in the left menu bar to start building the app on your iPhone. This process may take some time.</li>
                            <div class="row">
                                <div class="col-xl-7">
                                    <a class="img-popup">
                                        <img src="/product/efunding/documentation/assets/images/developmentAndTesting/build_and_run.webp" alt="build">
                                    </a>
                                </div>
                            </div>
                            <li><b>Completion Message:</b> Once the build process is completed successfully, you’ll see a message indicating the successful build.</li>
                            <div class="row">
                                <div class="col-xl-7">
                                    <a class="img-popup">
                                        <img src="/product/efunding/documentation/assets/images/developmentAndTesting/build_succeeded.webp" alt="build">
                                    </a>
                                </div>
                            </div>
                        </ol>
                    </li>
                    <p><b class="text--danger">Conclusion:</b> By following these steps, you can build and run your Flutter app on both Android and iOS devices. Ensure that your development environment is properly configured and that you’ve trusted your device for testing on iOS. If you encounter any issues during the process, refer to the Flutter documentation or seek assistance from the Flutter community. Happy app development!</p>
                </ul>
            </div>
        </div>
    </div>
</div>
<div class="page-change-area">
    <div class="navigation-wrapper">
        <router-link :to="{ name: 'AppInstallation'}" class="left"><i class="las la-angle-left me-1"></i> App Installation</router-link>
        <router-link :to="{ name: 'AndroidAppDeployment'}" class="right">Android App Deployment <i class="las la-angle-right ms-1"></i></router-link>
    </div>
</div>
<!--~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    End Server Requirements Page
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~-->
</template>
<script>
export default {
    name: 'DevelopmentAndTestingPage',
}
</script>